import { SupportChatApiError } from './types';
import { supportChatFetch } from './http';
export const SUPPORT_CHAT_PLAYER_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
export const SUPPORT_CHAT_GUEST_ATTACHMENT_MAX_BYTES = 5 * 1024 * 1024;
export const SUPPORT_CHAT_ATTACHMENT_MAX_BYTES = SUPPORT_CHAT_PLAYER_ATTACHMENT_MAX_BYTES;
export const SUPPORT_CHAT_ATTACHMENT_CONTENT_TYPES = [
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/gif'
];
export function isAllowedSupportChatAttachmentType(contentType) {
    return SUPPORT_CHAT_ATTACHMENT_CONTENT_TYPES.includes(contentType);
}
async function parseJson(res) {
    const text = await res.text();
    if (!text)
        return undefined;
    try {
        return JSON.parse(text);
    }
    catch {
        throw new SupportChatApiError('Invalid JSON response', res.status, text);
    }
}
async function expectOk(res) {
    if (res.ok)
        return;
    let body;
    try {
        body = await res.json();
    }
    catch {
        body = await res.text();
    }
    throw new SupportChatApiError(`Support chat HTTP ${res.status}`, res.status, body);
}
export async function createSupportAttachmentUpload(conversationId, contentType, size) {
    const res = await supportChatFetch(`/conversations/${encodeURIComponent(conversationId)}/attachments`, {
        method: 'POST',
        json: { content_type: contentType, size }
    });
    await expectOk(res);
    return parseJson(res);
}
export async function uploadSupportAttachmentToS3(upload, file, contentType) {
    const headers = new Headers(upload.headers ?? {});
    if (!headers.has('Content-Type')) {
        headers.set('Content-Type', contentType);
    }
    const res = await fetch(upload.upload_url, {
        method: upload.method || 'PUT',
        headers,
        body: file
    });
    if (!res.ok) {
        throw new SupportChatApiError(`Attachment upload HTTP ${res.status}`, res.status);
    }
}
